import { http } from './http'

export interface UserAddData {
	username: string;
	password: string; // sm4加密
	name: string;
	group: string;
	team: string; // 厂站id，多个id用,分割
	check: string; // username + password后用sm3加密
	iv?: string; // 随机生成的16位字符串
}

export interface UserUpdateData {
	guid: string;
	name: string;
	group?: string;
	team?: string;
}

export interface PassUpdateData {
	username: string;
	password: string;
	newpassword: string;
	iv: string;
	check: string; // username + password + newpassword后用sm3加密
}

export interface LoginData {
	username: string;
	password: string; // 随机生成的16位<iv>sm4加密后的密码
	iv: string; // 随机生成的16位字符串
	timestamp: number; // 服务器时间
	check: string; // username + password + key后用sm3加密
	captcha_data: string; // 验证码内容
	captcha_id: string; // 验证码id
}

// 获取验证码
export async function queryCaptcha() {
	return await http({ url: '/user/captcha', method: 'get' })
}

// 更新用户
export async function updateUser(user: UserUpdateData) {
	return await http({ url: '/user/update/info', method: 'post', data: user })
}

// 更新密码
export async function updatePassword(data: PassUpdateData) {
	return await http({ url: '/user/update/password', method: 'post', data })
}

// 用户登录
export async function login(data: LoginData) {
	return await http({ url: '/user/login', method: 'post', data })
}

// 用户登出
export async function logout() {
	return await http({ url: '/user/logout', method: 'post' })
}

// 获取用户列表
export async function getUserList() {
	return await http({ url: '/user/list', method: 'get' })
}

// 新增用户
export async function addUser(user: UserAddData) {
	return await http({ url: '/user/create', method: 'post', data: user })
}

// 删除用户
export async function deleteUser(guid: string) {
	return await http({ url: '/user/delete', method: 'post', data: { guid } })
}

// 获取菜单列表
export async function getMenuList(data) {
	return await http({ url: '/user/menu', method: 'get', data })
}

// 重鉴权
export async function checkPassword(data) {
	return await http({ url: '/user/recheck', method: 'post', data })
}